export const TransportEventSalesInvoiceStates = {
    Unknown: 0,
    Unprocessed: 1,
    NotToBeInvoiced: 2,
    Accepted: 3,
    Denied: 4,
    Waiting: 5,
    Completed: 6,
    Corrected: 7,
    ReadyForSalesInvoice: 8
};

export const TransportEventPurchaseInvoiceStates = {
    Unknown: 0,
    Unprocessed: 1,
    NotToBeInvoiced: 2,
    Accepted: 3,
    Denied: 4,
    Waiting: 5,
    Completed: 6
};

export const KelaTransportEventSalesInvoiceStates = {
    Unknown: 0,
    Unprocessed: 1,
    NotToBeInvoiced: 2,
    Accepted: 3,
    Completed: 6
};

export const KelaTransportEventPurchaseInvoiceStates = {
    Unknown: 0,
    Unprocessed: 1,
    NotToBeInvoiced: 2,
    Accepted: 3,
    Completed: 6
};

export const TransportEventInvoicingMixin = {
    data() {
        return {
            salesInvoiceStates: TransportEventSalesInvoiceStates,
            purchaseInvoiceStates: TransportEventPurchaseInvoiceStates,
            kelaSalesInvoiceStates: KelaTransportEventSalesInvoiceStates,
            kelaPurchaseInvoiceStates: KelaTransportEventPurchaseInvoiceStates
        };
    },
    methods: {
        salesInvoiceStatusToTranslationKey: function(value) {
            switch (value) {
            case TransportEventSalesInvoiceStates.Unknown:
                return "invoicing.transportEventSalesInvoiceStates.unknown";
            case TransportEventSalesInvoiceStates.Unprocessed:
                return "invoicing.transportEventSalesInvoiceStates.unprocessed";
            case TransportEventSalesInvoiceStates.NotToBeInvoiced:
                return "invoicing.transportEventSalesInvoiceStates.notToBeInvoiced";
            case TransportEventSalesInvoiceStates.Accepted:
                return "invoicing.transportEventSalesInvoiceStates.accepted";
            case TransportEventSalesInvoiceStates.Denied:
                return "invoicing.transportEventSalesInvoiceStates.denied";
            case TransportEventSalesInvoiceStates.Waiting:
                return "invoicing.transportEventSalesInvoiceStates.waiting";
            case TransportEventSalesInvoiceStates.Completed:
                return "invoicing.transportEventSalesInvoiceStates.completed";
            case TransportEventSalesInvoiceStates.Corrected:
                return "invoicing.transportEventSalesInvoiceStates.corrected";
            case TransportEventSalesInvoiceStates.ReadyForSalesInvoice:
                return "invoicing.transportEventSalesInvoiceStates.readyForSalesInvoice";
            };
        },
        purchaseInvoiceStatusToTranslationKey: function(value) {
            switch (value) {
            case TransportEventPurchaseInvoiceStates.Unknown:
                return "invoicing.transportEventPurchaseInvoiceStates.unknown";
            case TransportEventPurchaseInvoiceStates.Unprocessed:
                return "invoicing.transportEventPurchaseInvoiceStates.unprocessed";
            case TransportEventPurchaseInvoiceStates.NotToBeInvoiced:
                return "invoicing.transportEventPurchaseInvoiceStates.notToBeInvoiced";
            case TransportEventPurchaseInvoiceStates.Accepted:
                return "invoicing.transportEventPurchaseInvoiceStates.accepted";
            case TransportEventPurchaseInvoiceStates.Denied:
                return "invoicing.transportEventPurchaseInvoiceStates.denied";
            case TransportEventPurchaseInvoiceStates.Waiting:
                return "invoicing.transportEventPurchaseInvoiceStates.waiting";
            case TransportEventPurchaseInvoiceStates.Completed:
                return "invoicing.transportEventPurchaseInvoiceStates.completed";
            };
        }
    },
    filters: {
        salesInvoiceStatusToIcon: function(value) {
            switch (value) {
            case TransportEventSalesInvoiceStates.Unprocessed:
                return "mdi-new-box";
            case TransportEventSalesInvoiceStates.Waiting:
            case TransportEventSalesInvoiceStates.ReadyForSalesInvoice:
                return "mdi-av-timer";
            case TransportEventSalesInvoiceStates.Accepted:
                return "mdi-check-circle-outline";
            case TransportEventSalesInvoiceStates.Completed:
            case TransportEventSalesInvoiceStates.Corrected:
                return "mdi-check-circle";
            case TransportEventSalesInvoiceStates.NotToBeInvoiced:
            case TransportEventSalesInvoiceStates.Denied:
            default: return "mdi-alert";
            };
        },
        salesInvoiceStatusToColor: function(value) {
            switch (value) {
            case TransportEventSalesInvoiceStates.Waiting:
            case TransportEventSalesInvoiceStates.ReadyForSalesInvoice:
            case TransportEventSalesInvoiceStates.NotToBeInvoiced:
                return "";
            case TransportEventSalesInvoiceStates.Unprocessed:
            case TransportEventSalesInvoiceStates.Accepted:
                return "primary";
            case TransportEventSalesInvoiceStates.Completed:
            case TransportEventSalesInvoiceStates.Corrected:
                return "success";
            case TransportEventSalesInvoiceStates.Denied:
            default: return "error";
            };
        },
        purchaseInvoiceStatusToIcon: function(value) {
            switch (value) {
            case TransportEventPurchaseInvoiceStates.Unprocessed:
                return "mdi-new-box";
            case TransportEventPurchaseInvoiceStates.Waiting:
                return "mdi-av-timer";
            case TransportEventPurchaseInvoiceStates.Accepted:
                return "mdi-check-circle-outline";
            case TransportEventPurchaseInvoiceStates.Completed:
                return "mdi-check-circle";
            case TransportEventPurchaseInvoiceStates.NotToBeInvoiced:
            case TransportEventPurchaseInvoiceStates.Denied:
            default: return "mdi-alert";
            };
        },
        purchaseInvoiceStatusToColor: function(value) {
            switch (value) {
            case TransportEventPurchaseInvoiceStates.Waiting:
            case TransportEventPurchaseInvoiceStates.NotToBeInvoiced:
                return "";
            case TransportEventPurchaseInvoiceStates.Unprocessed:
            case TransportEventPurchaseInvoiceStates.Accepted:
                return "primary";
            case TransportEventPurchaseInvoiceStates.Completed:
                return "success";
            case TransportEventPurchaseInvoiceStates.Denied:
            default: return "error";
            };
        }
    }
};
